import {
  CRow,
  CAccordion,
  CAccordionItem,
  CAccordionHeader,
  CAccordionBody,
} from '@coreui/react-pro'
import React, { useEffect, useState } from 'react'
import OverseasPlayerListing from './OverseasPlayerListing'
import CommonService from 'src/service/CommonService'
import OverseasPlayerBulkUpdate from './OverseasPlayerBulkdUpdate'

const OverseasePlayer = () => {
  const [users, setUsers] = useState([])
  const [refreshKey, setRefreshKey] = useState(0)
  const [externalPlayerTag, setExternalPlayerTag] = useState(0)

  const [externalPlayerList, setExternalPlayerList] = useState([])

  useEffect(() => {
    CommonService.gameStructureInfo().then((res) => {
      if (res.status === 200) {
        setExternalPlayerTag(res.game_data?.external_player_tag || 0)
        setExternalPlayerList(res.externalPlayerList || [])
      }
    })
  }, [])

  const getTagNameById = (id, list) => {
    const tag = list?.find((item) => item.id === Number(id))
    return tag ? tag.name : 'External'
  }

  const title = `${getTagNameById(externalPlayerTag, externalPlayerList)} Players`
  return (
    <>
      <CRow>
        <CAccordion activeItemKey={2}>
          <CAccordionItem itemKey={2}>
            <CAccordionHeader>
              {' '}
              <strong>Bulk {title} Update</strong>
            </CAccordionHeader>
            <CAccordionBody>
              <OverseasPlayerBulkUpdate
                setRefreshKey={setRefreshKey}
                externalPlayerTag={externalPlayerTag}
                externalPlayerList={externalPlayerList}
              />
            </CAccordionBody>
          </CAccordionItem>
        </CAccordion>
      </CRow>
      <CRow>
        <CAccordion activeItemKey={1}>
          <CAccordionItem itemKey={1}>
            <CAccordionHeader>
              <strong>Manage {title}</strong>
            </CAccordionHeader>

            <CAccordionBody>
              <OverseasPlayerListing
                users={users}
                setUsers={setUsers}
                refreshKey={refreshKey}
                setRefreshKey={setRefreshKey}
                externalPlayerTag={externalPlayerTag}
                externalPlayerList={externalPlayerList}
              />
            </CAccordionBody>
          </CAccordionItem>
        </CAccordion>
      </CRow>
    </>
  )
}

export default OverseasePlayer
